import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { isProjectChangeState } from 'state/atoms';

const usePageLeave = () => {
  const isProjectChange = useRecoilValue(isProjectChangeState);

  useEffect(() => {
    if (isProjectChange) {
      window.onbeforeunload = function () {
        return '';
      };
    }

    return () => {
      window.onbeforeunload = null;
    };
  }, [isProjectChange]);
};

export default usePageLeave;
